"use client";

import React from "react";
var __jsx = React.createElement;
import APP_CONFIGURATION from '@lib/app.config';
import { cn } from '@lib/cn';
import { contactEmail, contactSupportNumber } from '@lib/util/link-redirection-ops';
import Icons from '../../../icons';
import { useTranslations } from 'next-intl';
import useCssModules from '@lib/hooks/use-css-modules';
const SupportContactItems = _ref => {
  var _cssModules$footers$f;
  let {
    className,
    itemsClassName,
    color,
    phoneIcon,
    emailIcon,
    iconSize = "23"
  } = _ref;
  const t = useTranslations("Shared.Layout");
  const {
    cssModules
  } = useCssModules();
  const {
    supportContactContainerClassNames,
    supportContactTextContainerClassNames,
    supportContactItemTextContainerClassNames,
    supportContactItemTitleClassNames,
    supportContactItemDescriptionClassNames,
    supportContactHeadsetIconClassNames,
    supportContactEmailIconClassNames
  } = (_cssModules$footers$f = cssModules === null || cssModules === void 0 ? void 0 : cssModules.footers.footerInterbank) !== null && _cssModules$footers$f !== void 0 ? _cssModules$footers$f : {};
  return __jsx("div", {
    className: cn(supportContactContainerClassNames, className)
  }, __jsx("div", {
    className: cn(supportContactTextContainerClassNames, itemsClassName),
    onClick: () => contactSupportNumber()
  }, phoneIcon || __jsx(Icons.headset, {
    className: supportContactHeadsetIconClassNames
  }), __jsx("div", {
    className: supportContactItemTextContainerClassNames
  }, __jsx("p", {
    className: supportContactItemTitleClassNames
  }, t("SUPPORT_BANK_TITLE")), __jsx("p", {
    className: supportContactItemDescriptionClassNames
  }, APP_CONFIGURATION.config.contactInformation.bankPhoneNumber), __jsx("p", {
    className: supportContactItemDescriptionClassNames
  }, t("SUPPORT_BANK_MESSAGE")))), __jsx("div", {
    className: cn(supportContactTextContainerClassNames, itemsClassName),
    onClick: () => contactSupportNumber()
  }, phoneIcon || __jsx(Icons.headset, {
    className: supportContactHeadsetIconClassNames
  }), __jsx("div", {
    className: supportContactItemTextContainerClassNames
  }, __jsx("p", {
    className: supportContactItemTitleClassNames
  }, t("SUPPORT_TRAVEL_TITLE")), __jsx("p", {
    className: supportContactItemDescriptionClassNames
  }, APP_CONFIGURATION.config.contactInformation.phoneNumber), __jsx("p", {
    className: supportContactItemDescriptionClassNames
  }, t("SUPPORT_TRAVEL_MESSAGE")))), __jsx("div", {
    className: cn(supportContactTextContainerClassNames, itemsClassName),
    onClick: () => contactEmail()
  }, emailIcon || __jsx(Icons.mail, {
    className: supportContactEmailIconClassNames
  }), __jsx("p", {
    className: supportContactItemDescriptionClassNames
  }, APP_CONFIGURATION.config.contactInformation.email)));
};
export default SupportContactItems;